import { render, staticRenderFns } from "./ChannelTypeChart.vue?vue&type=template&id=50436d9d&"
import script from "./ChannelTypeChart.vue?vue&type=script&lang=js&"
export * from "./ChannelTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports